'use client'

import { cn } from 'utils/cn'
import { useScrollPercentage } from '../utils/hooks/useScrollPercentage'
import { Progressbar } from './Progressbar'

export interface ProgressbarScrollingProps {
  id?: string
  className?: string
}

export const ProgressbarScrolling = ({
  id,
  className,
}: ProgressbarScrollingProps) => {
  const scrollPercentage = useScrollPercentage()

  return (
    <Progressbar
      aria-hidden
      className={cn(
        'fixed top-0 z-[90] max-h-1 w-full rounded-none opacity-100 transition-all duration-300',
        {
          'h-0 opacity-0': scrollPercentage < 3 || !scrollPercentage,
        },
        {
          'fixed top-0 z-[100]': scrollPercentage >= 3,
        },
        className,
      )}
      id={id}
      size='sm'
      value={scrollPercentage}
    />
  )
}
